import { Box, Table, Tbody, Td, Th, Thead, Tr } from "@chakra-ui/react";
import { formatAmountInINR } from "jsFunctions/formatAmountInINR";
import { useCallback } from "react";
import {  useSelector } from "react-redux";

const GstAmountTable = ({ editGstInfo, currentGstInfo, type }) => {
  const vendorList = useSelector((state) => state.vendorData);

  const fetchCompanyName = useCallback((companyId) => {
    const vendor = vendorList.find((vendor) => vendor._id === companyId);
    
    if (vendor) {
      return vendor.name; 
    } else {
      return ""; 
    }
  }, [vendorList]);
  

    return (

        type === 'current' ?
        <div className="info-table change-modal-table">

        <Table className="table-info">
          <Thead>
            <Tr>
              <Th>Base Amount</Th>
              <Th>Company Name</Th>
              <Th>GST Number</Th>
              <Th>GST Percentage</Th>

            </Tr>
          </Thead>
          <Tbody>
            {editGstInfo?.map((item, index) => {
              return (
                <Tr>
                  <Td className={`${item?.bsAmt !== currentGstInfo?.[index]?.bsAmt ? 'data_compare_red' : ''}`}><Box>{formatAmountInINR( parseFloat(item?.bsAmt || 0))}</Box></Td>
                  <Td className={`${item?.vId !== currentGstInfo?.[index]?.vId ? 'data_compare_red' : ''}`}>{fetchCompanyName(item?.vId)}</Td>
                  <Td className={`${item?.gstNo !== currentGstInfo?.[index]?.gstNo ? 'data_compare_red' : ''}`}>{item?.gstNo}</Td>

                  <Td className={`${item?.prc !== currentGstInfo?.[index]?.prc ? 'data_compare_red' : ''}`}>{item?.prc ? `${item?.prc} %` : ''}</Td>

                </Tr> 

              );
            })}
          </Tbody>
        </Table>
      </div>
            :
            <div className="info-table change-modal-table">

                    <Table className="table-info">
                      <Thead>
                        <Tr>
                          <Th>Base Amount</Th>
                          <Th>Company Name</Th>
                          <Th>GST Number</Th>

                          <Th>GST Percentage</Th>

                        </Tr>
                      </Thead>
                      <Tbody>
                        {currentGstInfo?.map((item, index) => {
                          return (
                            <Tr>
                              <Td className={`${item?.bsAmt !== editGstInfo?.[index]?.bsAmt ? 'data_compare_green' : ''}`}><Box   >{formatAmountInINR(parseFloat(item?.bsAmt || 0))}</Box></Td>
                              <Td className={`${item?.vId !== editGstInfo?.[index]?.vId ? 'data_compare_green' : ''}`}>{fetchCompanyName(item?.vId)}</Td>
                              <Td className={`${item?.gstNo !== editGstInfo?.[index]?.gstNo ? 'data_compare_green' : ''}`}>{item?.gstNo}</Td>
                              <Td className={`${item?.prc !== editGstInfo?.[index]?.prc ? 'data_compare_green' : ''}`}>{item?.prc ? `${item?.prc} %` : ''}</Td>

                            </Tr> 

                          );
                        })}
                      </Tbody>
                    </Table>
                  </div>

    )


}

export default GstAmountTable;
